/* unplugin-vue-components disabled */import script from "./layout.vue?vue&type=script&setup=true&name=Layout&lang=js"
export * from "./layout.vue?vue&type=script&setup=true&name=Layout&lang=js"

import "./layout.vue?vue&type=style&index=0&id=44c314b9&lang=scss"

const __exports__ = script;

export default __exports__